<div>
  <h3 class="m-t-xl">{{ contentData?.device }}</h3>
  <div class="row blade fractional border-t m-t-lg">
    <div class="col-12">
      <a
        href="javascript:void(0)"
        id="changePhoneNumber"
        class="row header"
        [class.disabled]="isTouristPlan || !permissionEnabled"
        (click)="onChangePhoneNumber()"
      >
        <div class="col-10 header-container">
          <h6>{{ contentData?.changePhoneNumber }}</h6>
        </div>
        <span class="carret"> <i class="fa def fa-angle-right"></i></span>
      </a>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-accordion [multiple]="true" id="p-accordion-default-12">
        <p-accordionTab [selected]="false" class="fractional internal" id="help">
          <p-header>
            <div class="row n-p">
              <div class="col-12">
                <h6 class="title">{{ contentData?.help }}</h6>
              </div>
            </div>
          </p-header>
          <div class="p-content no-t-p">
            <div class="row blade fractional blade-right border-t">
              <div class="col-12">
                <a
                  (click)="onClick()"
                  id="deviceSupport"
                  class="row header"
                  aria-label="clickable action"
                >
                  <div class="col-10 header-container">
                    <h6>{{ contentData?.deviceSupport }}</h6>
                  </div>
                  <span class="carret right-align right-align right-align">
                    <i class="fa def fa-angle-right"></i
                  ></span>
                </a>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
